<div class="chart-modal">
  <!-- Header row -->
  <div class="chart-modal__header">
    <!-- Left: Title + Trend -->
    <div class="title-and-trend">
      <h3 class="chart-title">{{ title | transloco }}</h3>
      @if (!isLoading && hasData()) {
        <app-graph-trend-icon
          [percentageChange]="percentageChange"
          [formattedChange]="formatPercentChange()"
          [formatValue]="formatValue()"
          [isUptrendPositive]="isUptrendPositive()">
        </app-graph-trend-icon>
      }
    </div>

    <!-- Right: Filters + menu + close -->
    <div class="chart-modal__header-actions">
      <div class="filters d-flex align-items-center gap-2">
        <app-account-filter
          [filter]="accountFilter"
          (filterChanged)="onAccountFilterChange($event)">
        </app-account-filter>

        <div class="common-drop-down date-height">
          <app-date-filter
            [filter]="dateFilter"
            [isButtonIntervalSelector]="false"
            [disabledIntervals]="disabledIntervals"
            [defaultInterval]="defaultInterval"
            (filterChanged)="onDateFilterChange($event)">
          </app-date-filter>
        </div>
      </div>

      <!-- close -->
      <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="close()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M18 6L6 18M6 6l12 12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
          </path>
        </svg>
      </button>
    </div>
  </div>

  <!-- Chart area -->
  <div class="chart-modal__body">
    @defer (on timer(100ms)) {
      @if (!isLoading && hasData()) {
        <div class="chart-modal__chart">
          <app-stacked-bar-chart
            class="chart-fill"
            [data]="chartData"
            [chartHeight]="chartHeight"
            [margin]="{ top: 20, right: 10, bottom: 30, left: 0 }"
            [yTicks]="yTicks"
            [subgroups]="subgroups"
            [legend]="legendItems"
            [tooltipUnit]="'R'"
            [barWidthPx]="20"
            [stackOrder]="['corrective', 'preventative']"
            (exportClicked)="onExport()">
          </app-stacked-bar-chart>
        </div>
      } @else if (!isLoading && !hasData()) {
        <div class="chart-modal__empty">
          <app-empty-state></app-empty-state>
        </div>
      }
    }

    @if (isLoading) {
      <div class="chart-modal__loader">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    }
  </div>
</div>